import React, { FC, Fragment } from 'react';
import { formatDate } from 'utils/format';
import { TableCell, TableRow, Chip, Tooltip } from '@mui/material';
import { Organization } from 'models/organization';
import { useTranslation } from 'react-i18next';
import ResolveTransportProblemFlagButton from 'components/shared/resolve-transport-problem-flag-button/resolve-transport-problem-flag-button.component';
import { TransportOrder, TransportServices } from 'models/transport';

type TransportOrderListItemProps = {
    transport: TransportOrder;
    onFlagClick: (transportId: string) => void;
    onListItemClick: (transport: TransportOrder) => void;
};
const TransportOrderListItem: FC<TransportOrderListItemProps> = ({
    transport,
    onFlagClick,
    onListItemClick,
}: TransportOrderListItemProps) => {
    const { t: translate } = useTranslation(['transport']);

    const colorMap: Record<string, string> = {
        PICKUP: '#ed6c02',
        DELIVERY: '#00438a',
    };

    const handleFlagClick = () => {
        onFlagClick(transport._id as string);
    };

    return (
        <Fragment>
            <TableRow
                sx={{ cursor: 'pointer' }}
                hover
                onClick={() => {
                    onListItemClick(transport);
                }}
            >
                <TableCell align="right">
                    {transport.hasProblem ? (
                        <ResolveTransportProblemFlagButton resolveTransportProblem={handleFlagClick} />
                    ) : undefined}
                </TableCell>
                <TableCell>
                    <Tooltip title={translate(`transport:${transport.serviceCode}`).toString()} placement="right">
                        <Chip
                            label={transport.serviceCode === TransportServices.PICKUP ? 'U' : 'L'}
                            sx={{
                                color: '#fff',
                                backgroundColor: colorMap[transport.serviceCode ? transport.serviceCode : ''],
                            }}
                        />
                    </Tooltip>
                </TableCell>
                <TableCell sx={{ minWidth: 100 }}>{transport.externalReference}</TableCell>
                <TableCell sx={{ maxWidth: 300 }}>{(transport.lab as Organization)?.name}</TableCell>
                <TableCell sx={{ maxWidth: 300 }}>{(transport.clinic as Organization)?.name}</TableCell>
                <TableCell>{transport.manualPackageCount + (transport.orders?.length || 0)}</TableCell>
                <TableCell>{transport.comment}</TableCell>
                <TableCell>{translate(transport.status as string)}</TableCell>
                <TableCell sx={{ minWidth: 125 }}>{formatDate(transport.transportDate, 'date')}</TableCell>
            </TableRow>
        </Fragment>
    );
};

export default TransportOrderListItem;
